import React from 'react';
import { Notification } from './Notification';
import { requestNotification, requestNotificationV2 } from './RequestNotification';
import { IResponseNotification } from 'reducers/api/model';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { IStore } from 'reducers/index';
import { connect } from 'react-redux';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';

interface IState{
    count: number,
    list: any[],
    error: string,
    viewBell: boolean
}
interface IParams{
    target?: string
}

interface IMapStateToProps {
    featureToggles: IFeatureToggleModel[];
    isFeatureDataReady: boolean;
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    featureToggles: state.featureToggle.featureToggles,
    isFeatureDataReady: state.featureToggle.isFeatureDataReady,
});

interface IProps extends IParams, IMapStateToProps, RouteComponentProps {}
class _NotificationMain extends React.Component<IProps, IState> {
    constructor(props:any) {
        super(props);
        this.state = {
            count: 0,
            error: '',
            list: [],
            viewBell: true
        }
    }
    public componentDidMount(){
        this.handleLocation()
    }
    public componentDidUpdate(props:any){ 
        if(this.props.location.pathname !== props.location.pathname || this.props.isFeatureDataReady !== props.isFeatureDataReady){
            this.handleLocation()
        }
    }
    public handleLocation = () => {
        const url = location.pathname;
        this.setState({viewBell: !url.includes('exception-management/notifications/')})
        if(!url.includes('exception-management/notifications/') && this.props.isFeatureDataReady){
             isFeatureEnabled(FEATURE_TOGGLES.FINOPS_WEBAPI_REQUEST_NOTIFICATION, this.props.featureToggles)
                ? requestNotificationV2(this.processData, this.props.target)
                : requestNotification(this.processData, this.props.target)
        }
    }
    public processData = (data: IResponseNotification, errorMsg: string) => {
        this.setState({
            count: this.props.target? data.viewNotifications.length: data.count,
            list: data.viewNotifications,
            error: errorMsg
        })
    }
    public render() {
        return (<>
            {this.state.viewBell && <Notification displayAllBtn={this.props.target? false: true} count={this.state.count} list={this.state.list} error={this.state.error} />}
        </>);
    }
}

export const NotificationMain = withRouter(connect(mapStateToProps)(_NotificationMain));